import React, { useEffect, useState } from "react";

// css
import "./Carousel.css";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
const CrouselCard = ({ element,setValue,setInnerValue }) => {
  // console.log("element",element)
  // const [fontSize, setFontSize] = useState(14);
  // useEffect(()=>{
  //     const storedFontSize = localStorage.getItem("fontSizeLocal");
  //     if (storedFontSize) {
  //       setFontSize(storedFontSize);
  //     }
  // })

  // console.log("firstq", element.fontSize)

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div onClick={()=>{
      setValue(element?.stateTab)
      if(element?.setInnerValue){
        setInnerValue(element?.stateInnerTab)
      }
    }} className="div d-flex w-100 pr-0" style={{ height: "100px" }}>
      <div
        className="crousel-left-border"
        style={{ backgroundColor:General?.colorClass?General?.colorClass: "#101E8E" }}
      ></div>

      <div className="row p-0 m-0 d-flex w-100 bg-light justify-content-between">
        <div
          style={{
            backgroundColor: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "",
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
          }}
          className="col-12 d-flex justify-content-between align-items-center px-2"
        >
          <div>
            <p
              style={{
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
              className={`slider-text1 mb-0 ${General?.textClass}`}
            >
              {element.text}
            </p>
            {/* Alert icon and pending action text */}
            {element.stateTab === 2 && element.customerPendingCount > 0 && (
              <div style={{ display: "flex", alignItems: "center", marginTop: "4px" }}>
                <div 
                  style={{
                    width: "0",
                    height: "0",
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "14px solid #ff6b35",
                    marginRight: "6px",
                    position: "relative"
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "2px",
                      left: "-1px",
                      fontSize: "8px",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    !
                  </div>
                </div>
                <span 
                  style={{
                    fontSize: `${0.7 * General.accessibility.fontSize}rem`,
                    color: "#ff6b35",
                    fontWeight: "500"
                  }}
                  className={General?.textClass}
                >
                  you have {element.customerPendingCount} requests needing action
                </span>
              </div>
            )}
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50px",
              backgroundColor: "#eee",
            }}
          >
            {/* <img
              className=" "
              style={{ width: "16px", height: "16px" }}
              src={element.image}
              alt=""
            /> */}
            {element.image}
            
          </div>
        </div>

        <div
          style={{
            backgroundColor: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "",
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
          className={`col-12 px-2 pb-2 ${General?.textClass}`}
        >
          <div>
            {" "}
            <p
              style={{
                fontSize: `${1.7 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
              className={`mb-0 slider-num1 ${General?.textClass}`}
            >
              {" "}
              {element.num}{" "}
            </p>
          </div>
          <div className="w-100 d-flex flex-column align-items-center">
            {element.testbefore1 ? (
              <p
                style={{
                  fontSize: `${0.56 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
                className={`mb-0 slider-card1-text1 ${General?.textClass}`}
              >
                {element.testbefore1} {element.textbeforenumber1}{" "}
                {element.testafter1}
              </p>
            ) : (
              ""
            )}
            {element.testbefore2 ? (
              <p
                style={{
                  fontSize: `${0.56 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : element.isOverdue2
                    ? "#d46b6b"
                    : "",
                }}
                className={`mb-0 slider-card1-text1 ${General?.textClass}`}
              >
                {element.testbefore2} {element.textbeforenumber2}{" "}
                {element.testafter2}
              </p>
            ) : (
              ""
            )}
            {element.commonText0 ? (
              <p
                style={{
                  fontSize: `${0.56 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
                className={`mb-0 slider-card1-text1 ${General?.textClass}`}
              >
                {element.commonText0} 
              </p>
            ) : (
              ""
            )}
            {element.commonText ? (
              <p
                style={{
                  fontSize: `${0.56 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
                className={`mb-0 slider-card1-text1 ${General?.textClass}`}
              >
                {element.commonText} 
              </p>
            ) : (
              ""
            )}

            {element?.enable && (
              <>
                <p
                  style={{
                    fontSize: `${0.56 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                  }}
                  className={`mb-0 slider-card1-text1 ${General?.textClass}`}
                >
                  {element.enable}
                </p>
                <p
                  style={{
                    fontSize: `${0.56 * General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                  }}
                  className={`mb-0 slider-card1-text1 ${General?.textClass}`}
                >
                  {" "}
                  {element.textbeforenumber1} {element.testafter1}
                </p>
              </>
            )}
          </div>
        </div>

        {/* {element.enable ? (
          <div>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                width: "49px",
                height: "19px",
                backgroundColor: contrast?.contrastBackground?contrast?.contrastBackground:"#E7F2E5", color: contrast?.contrastColor?contrast?.contrastColor:''
              }}
            >
              <p style={{ fontSize: `${0.56 * General.accessibility.fontSize}rem`,color:contrast?.contrastColor?contrast?.contrastColor:"" }} className="mb-0 slider-card1-text1">{element.enable}</p>
            </div>
            {element.textbeforenumber1 ? (
              <p style={{ fontSize: `${0.56 * General.accessibility.fontSize}rem`,color:contrast?.contrastColor?contrast?.contrastColor:"" }} className="mb-0 slider-card1-text1">
                {" "}
                {element.textbeforenumber1} {element.testafter1}
              </p>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )} */}
      </div>
    </div>
  );
};

export default observer(CrouselCard);
{
  /* <div className="col-12 d-flex justify-content-between align-items-center px-2">
              <div>
                <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="slider-text1 mb-0">{element.text}</p>
              </div>
              <div className="d-flex justify-content-center align-items-center" style={{ width: '24px', height: "24px", borderRadius: "50px", backgroundColor: "#eee" }}>
                <img className=" " style={{ width: '16px', height: "16px" }} src={element.image} alt="" />
              </div>
            </div> */
}
{
  /* <div className="col-12 px-2 d-flex justify-content-between align-items-center">
              <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-num1"> {element.num} </p>
              <div className="w-100 d-flex flex-column align-items-center">


                {element.testbefore1 ? <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-card1-text1">{element.testbefore1} {element.textbeforenumber1} {element.testafter1}</p> : ''}
                {element.testbefore2 ? <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-card1-text1">{element.testbefore2} {element.textbeforenumber2} {element.testafter2}</p> : ''}
                {element.commonText0 ? <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-card1-text1">{element.commonText0}</p> : ''}
                {element.commonText ? <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-card1-text1">{element.commonText}</p> : ''}

                {element.enable ?
                  <div >
                    <div className="d-flex justify-content-center align-items-center" style={{ width: "49px", height: "19px", backgroundColor: "#E7F2E5" }}>
                      <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-card1-text1">{element.enable}</p>
                    </div>
                    {element.textbeforenumber1 ? <p style={{color:contrast?.contrastColor?contrast?.contrastColor:""}} className="mb-0 slider-card1-text1"> {element.textbeforenumber1} {element.testafter1}</p> : ''}
                  </div>

                  : ''}

              </div>
            </div> */
}
